export { default as Html } from './html';
//# sourceMappingURL=index.js.map